import { Trans, useTranslation } from 'react-i18next';

type Props = {
  prerequisitesTitles: string[];
};

export const PrerequisitesTooltip = ({ prerequisitesTitles }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ textAlign: 'left' }}>
        {prerequisitesTitles.length === 1 ? (
          <Trans
            i18nKey='SinglePrerequisiteTooltip'
            ns='learningHub'
            defaults='<bold>{{prerequisite}} is a prerequisite</bold> for this certification. Please complete it before proceeding.'
            values={{ prerequisite: prerequisitesTitles[0] }}
            components={{ bold: <strong /> }}
          />
        ) : (
          <div>
            <Trans
              i18nKey='MultiplePrerequisites'
              ns='learningHub'
              defaults='<bold>These are the prerequisites</bold> for this certification:'
              values={{ prerequisite: prerequisitesTitles[0] }}
              components={{ bold: <strong /> }}
            />
            <ul>
              {prerequisitesTitles.map((title) => (
                <li>{title}</li>
              ))}
            </ul>
            {t('CompletePrerequisites', { ns: 'learningHub', what: prerequisitesTitles.length > 1 ? 'them' : 'it' })}
          </div>
        )}
      </div>
    </>
  );
};
